"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaturesRegenerationAbilityHandler = exports.NaturesRegenerationActorAbilityFactory = exports.NaturesRegenerationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
class NaturesRegenerationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NaturesRegeneration;
        this.__typeName = "NaturesRegeneration";
    }
}
exports.NaturesRegenerationAbilityArgs = NaturesRegenerationAbilityArgs;
let NaturesRegenerationActorAbilityFactory = class NaturesRegenerationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NaturesRegeneration", "AllAllies", 2);
    }
};
NaturesRegenerationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NaturesRegeneration")
], NaturesRegenerationActorAbilityFactory);
exports.NaturesRegenerationActorAbilityFactory = NaturesRegenerationActorAbilityFactory;
let NaturesRegenerationAbilityHandler = class NaturesRegenerationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => {
                    const afterInstant = sequence.pushSequence("sequential")
                        .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "GreenHealingPillar"))
                        .pushSequence("parallel");
                    container.applyHealing({
                        sequence: afterInstant,
                        healerId: ability.invokerId,
                        targetId: allyId,
                        amount: container.getPercentOfBaseHealth(allyId, 10),
                        onApplied: sequence => {
                            container.applyBuff({
                                sequence,
                                creatorId: ability.invokerId,
                                targetId: allyId,
                                duration: Duration_1.Duration.Turns(4),
                                effect: new core_2.RegenerationEffectArgs("NaturesRegeneration", container.getPercentOfBaseHealth(allyId, 1))
                            });
                        }
                    });
                });
            }
        });
    }
};
NaturesRegenerationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NaturesRegeneration)
], NaturesRegenerationAbilityHandler);
exports.NaturesRegenerationAbilityHandler = NaturesRegenerationAbilityHandler;
